<template>
  <div>
    <el-table
        border
        stripe
        :data="inspectionReport.panVOS"
        style="width: 100%"
        class="table"
        cellpadding="0"
        cellspacing="0">
      <el-table-column prop="name" label="资料名称"/>
      <el-table-column prop="guid" label="发布版本">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="downLoad(scope.row.guid)">{{scope.row.guid}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="editableFileGuid" label="可编辑版本">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="downLoad(scope.row.editableFileGuid)">{{scope.row.editableFileGuid}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fileTypeName" label="资料类型" align="center" width="100"/>
      <el-table-column prop="cascadeNames" label="存放目录" show-overflow-tooltip/>
      <el-table-column prop="roleNames" label="发布对象" show-overflow-tooltip/>
      <el-table-column prop="creatorName" label="提交人" width="80" align="center"/>
    </el-table>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  export default {
    name: "",
    components: { HandleDetail },
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        activeName: "first",
        inspectionReport: {
          panVOS: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.$emit("loading-status", { loading: true });
        this.$http.get("basic", `panPublishProcess/${this.billId}`).then((resp) => {
          this.$emit("loading-status", { loading: false });
          this.inspectionReport = resp;
          console.log(resp);
        });
      },

      saveInspectionReports() {
        this.$http.post("basic", "inspectionReports/engineerSubmit", this.inspectionReport).then(() => {});
      },

      // 下载
      downLoad(key) {
        this.$http.exportFile("basic", `pans/downLoadFile_V1/${key}`).then((res) => {
          var a = document.createElement("a");
          a.href = res.config.url;
          a.click();
        });
      },

      doApprove() {
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        this.$emit("loading-status", { loading: true });
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", { loading: false });
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/FileReleaseAgenda",
            });
          })
          .catch(() => {
            this.$emit("loading-status", { loading: false });
          });
      },

      updateInspectionReportStatus() {
        this.$http.get("basic", `inspectionReports/updateInspectionReportStatus/${this.inspectionReport.pkid}`).then(() => {
          this.$message.success("退回到提交人成功！！！");
        });
      },
    },
  };
</script>

<style scoped>
.table tr td {
  border: 1px solid #dddddd;
  border-bottom: none;
  border-right: none;
  padding: 1%;
  min-width: 80px;
}
.table tr:last-child td {
  border-bottom: 1px solid #ddd;
}
.table tr td:last-child {
  border-right: 1px solid #ddd;
}
.tableLabel {
  text-align: center;
  background: #f4f7fa;
  width: 120px;
}
</style>
